export default __webpack_public_path__ + "static/media/stoop.5dac318a.gif";